import React, { Component } from 'react';
import { Grid, Cell } from 'react-md';
import { Link, Redirect } from 'react-router-dom';
import validate from 'validate.js';
import 'whatwg-fetch';
import slugify from 'slugify';

import config from '../config';

import 'fine-uploader/fine-uploader/fine-uploader-new.css';
import Dropzone from 'react-fine-uploader/dropzone';
import CancelButton from 'react-fine-uploader/cancel-button';
import DeleteButton from 'react-fine-uploader/delete-button';
import Filename from 'react-fine-uploader/filename';
import FileInput from 'react-fine-uploader/file-input';
import ProgressBar from 'react-fine-uploader/progress-bar';
import Status from 'react-fine-uploader/status';

import FineUploaderS3 from 'fine-uploader-wrappers/s3';

import './Uploader.css';

import { state, isStateEmpty } from '../services/state';

validate.validators.allFilesCompleted = function(
	value,
	options,
	key,
	attributes
) {
	let isValid = true;

	state.submittedFiles.map(fileId => {
		if (value[fileId] && value[fileId] !== 'upload successful') {
			isValid = false;
		}
	});

	if (!isValid) {
		return 'must all be complete';
	}
};

const uploader = new FineUploaderS3({
	options: {
		chunking: {
			enabled: true
		},
		debug: true,
		request: {
			endpoint: `https://${config.awsBucketName}.s3.amazonaws.com`,
			accessKey: config.awsAccessKey
		},
		signature: {
			endpoint: `${config.host}/wp-json/fresh-uploader/v1/upload`
		},
		uploadSuccess: {
			endpoint: `${config.host}/wp-json/fresh-uploader/v1/upload`
		},
		// retry: {
		//   enableAuto: true // defaults to false
		// },
		deleteFile: {
			enabled: true,
			forceConfirm: true,
			method: 'POST',
			endpoint: `${config.host}/wp-json/fresh-uploader/v1/upload`
		},
		objectProperties: {
			key: function(fileId) {
				return `${slugify(
					state.clientCompanyName
				)}/${uploader.methods.getFile(fileId).qqPath ||
					''}${uploader.methods.getName(fileId)}`;
			}
		}
	}
});

const isFileGone = status => {
	return ['canceled', 'deleted'].indexOf(status) >= 0;
};

class Uploader extends Component {
	constraints = {
		submittedFiles: {
			presence: { allowEmpty: false }
		},
		fileStatuses: {
			allFilesCompleted: true
		}
	};

	constructor() {
		super();

		this.state = {
			submittedFiles: state.submittedFiles,
			shouldOverrideProgress: {}
		};
	}

	componentDidMount() {
		uploader.on('statusChange', (id, oldStatus, newStatus) => {
			if (newStatus === 'submitted') {
				const submittedFiles = this.state.submittedFiles;
				submittedFiles.push(id);
				state.submittedFiles = submittedFiles;
				this.setState({ submittedFiles });
			} else if (isFileGone(newStatus)) {
				const submittedFiles = this.state.submittedFiles;
				const indexToRemove = submittedFiles.indexOf(id);
				submittedFiles.splice(indexToRemove, 1);
				state.submittedFiles = submittedFiles;
				this.setState({ submittedFiles });
			} else {
				// timeout is needed to get the validity in render to be checked on the next tick of the event loop
				setTimeout(() => {
					this.setState({ submittedFiles: state.submittedFiles });
				}, 20);
			}

			state.fileStatuses[id] = newStatus;
		});

		state.submittedFiles.map(fileId => {
			// set status for all status types
			uploader.methods._uploadData.setStatus(
				fileId,
				state.fileStatuses[fileId]
			);

			// override progress only if the upload is complete
			if (
				state.fileStatuses[fileId] ===
				uploader.qq.status.UPLOAD_SUCCESSFUL
			) {
				const { shouldOverrideProgress } = this.state;
				shouldOverrideProgress[fileId] = true;
				this.setState({
					shouldOverrideProgress
				});
			}
		});
	}

	isValid = () => {
		this.validation = validate(state, this.constraints);
		return !this.validation;
	};

	nextClick = event => {
		if (!this.isValid()) {
			event.stopPropagation();
			event.preventDefault();
			return false;
		}

		fetch(`${config.host}/wp-json/fresh-uploader/v1/notify`, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json'
			},
			body: JSON.stringify({
				...state,
				...{
					selectedContacts: Array.from(state.selectedContacts),
					submittedFiles: state.submittedFiles.map(id => {
						return uploader.methods.getName(id);
					})
				}
			})
		})
			.then(function(response) {
				return response.json();
			})
			.then(function(responseJson) {
				console.log({ responseJson });
			})
			.catch(function(ex) {
				console.log('parsing failed', ex);
			});
	};

	onProcessingDroppedFiles = files => {
		console.log('onProcessingDroppedFiles', files);
	};

	onProcessingDroppedFilesComplete = files => {
		console.log('onProcessingDroppedFilesComplete', files);
	};

	render() {
		if (isStateEmpty()) {
			return <Redirect to="/" />;
		}

		const { submittedFiles, shouldOverrideProgress } = this.state;
		const isValid = this.isValid();

		const progressOverride = id => {
			return shouldOverrideProgress[id] ? 'override' : '';
		};

		return (
			<div className="Uploader">
				<Grid className="next-wrapper">
					<Cell size={6} tabletOffset={1} desktopOffset={3}>
						<Dropzone
							uploader={uploader}
							className="dropzone"
							onProcessingDroppedFiles={
								this.onProcessingDroppedFiles
							}
							onProcessingDroppedFilesComplete={
								this.onProcessingDroppedFilesComplete
							}
							multiple={true}
						>
							<div className="sub-section-title">
								Drop Files Here
							</div>
							<div className="or">or</div>
							<FileInput multiple uploader={uploader}>
								<button className="primary-button">
									Browse
								</button>
							</FileInput>
							<p className="upload-note">
								Note: Please compress your artwork into a ZIP
								file before uploading.
							</p>
						</Dropzone>
					</Cell>
				</Grid>

				<Grid className="next-wrapper">
					<Cell size={6} tabletOffset={1} desktopOffset={3}>
						<div className="files-wrapper">
							{submittedFiles.map(id => {
								return (
									<div className="file" key={id}>
										<div className="details-wrapper">
											<i className="uploader-icon uploader-icon-File" />
											<Filename
												id={id}
												uploader={uploader}
											/>
											<Status
												id={id}
												uploader={uploader}
											/>
											<ProgressBar
												id={id}
												uploader={uploader}
												hideOnStart={false}
												hideOnComplete={false}
												className={progressOverride(id)}
											/>
										</div>
										<CancelButton
											id={id}
											uploader={uploader}
										>
											<span className="cancel-icon">
												ⓧ
											</span>
										</CancelButton>
										<DeleteButton
											id={id}
											uploader={uploader}
										>
											<span className="delete-icon">
												ⓧ
											</span>
										</DeleteButton>
									</div>
								);
							})}
						</div>
					</Cell>
				</Grid>

				<Grid className="next-wrapper">
					<Cell size={6} tabletOffset={1} desktopOffset={3}>
						<Link to="/contacts" className="primary-button">
							<i className="uploader-icon uploader-icon-Previous-Arrow" />{' '}
							Previous
						</Link>
						<Link
							to="/finished"
							onClick={this.nextClick}
							className={`primary-button ${
								isValid ? '' : 'disabled'
							}`}
						>
							Finish
						</Link>
					</Cell>
				</Grid>
			</div>
		);
	}
}

export default Uploader;



// WEBPACK FOOTER //
// ./src/pages/Uploader.js